import { render } from "./PpcSettings.vue?vue&type=template&id=366ee0fa&scoped=true"
import script from "./PpcSettings.vue?vue&type=script&lang=js"
export * from "./PpcSettings.vue?vue&type=script&lang=js"

import "./PpcSettings.vue?vue&type=style&index=0&id=366ee0fa&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-366ee0fa"]])

export default __exports__